import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import Box from '../../components/containers/box';
import Button from '../../components/forms/button';
import { getColumnText, getPhrase } from '../../data/phrases';
import FlexBox from '../../components/containers/flexbox';
import FlexBoxBlock from '../../components/containers/flexboxblock';
import StaticLookup from '../../data/staticlookup';
import memoizeOne from 'memoize-one';
import $ from 'jquery';
import LookupInput from '../../components/forms/lookupinput';
import LookupListInput from '../../components/forms/lookuplistinput';
import DateInput from '../../components/forms/dateinput';
import TextInput from '../../components/forms/textinput';
import NumberInput from '../../components/forms/numberinput';

import Form from '../../components/forms/form';
import Cross from '../../components/forms/cross';
import FormItem from '../../components/forms/formitem';
import Icon from '../../components/icon';
import {getLookup} from '../../data/lookupstore';
import { getNextAutoFocusId } from '../../components/forms/autofocus';

const EMPTY_LIST = Immutable.List([]);

const EMPTY_AND = Immutable.Map({
	type: 'and',
	nodes: EMPTY_LIST
});

const EMPTY_OR = Immutable.Map({
	type: 'or',
	nodes: EMPTY_LIST
});

const EMPTY_CONDITION = Immutable.Map({
	type: 'condition'
});

function getColumnLookup(parentType, cols, entityName) {
	cols = cols.map(fc => {
		return {
			name: fc.name,
			text: getColumnText(fc.name, entityName, false, 'filterEditor')
		};
	}).sort((a, b) => a.text.localeCompare(b.text));
	const colItems = cols.map(fc => {
		return Immutable.fromJS({
			key: fc.name,
			cells: [fc.text]
		});
	});
	const blockType = (parentType === 'and' ? 'or' : 'and');
	const blockItem = parentType ? (
		Immutable.fromJS([
			{
				key: 's$block$' + blockType,
				cells: [getPhrase('filterEditor.block.' + blockType)]
			}
		])
	) : EMPTY_LIST;
	return StaticLookup(
		blockItem.concat(colItems)
	);
}

function mapColumns(cols) {
	let res = {};
	cols.forEach(col => {
		const name = col.name;
		res[name] = col;
	})
	return res;
}

// todo: zatim dam registraci sem, az se bude pouzivat i jinde, tak to dam tam

let _getFilterInputDefinition = function(col) {
	const type = col.type;
	if (type === 'Subquery') {
		return {
			type: 'subquery',
			columns: col.columns
		};
	} else if (type === 'Fulltext') {
		return {
			type: 'text',
			processValue: (value) => value ? value.replace('*', '%') : value
		};
	}
	return {
		type: 'text'
	};
};

export function registerFilterInputDefinitionCallback(func) {
	_getFilterInputDefinition = func;
}


function getFilterInputDefinition(col) {
	return _getFilterInputDefinition(col, 'filterEditor');
}


function createOperatorsForInput(type) {
	let res = [];
	if (type === 'subquery') {
		res.push('exists');
		res.push('notExists');
	} else {
		if (type === 'lookup') {
			res.push('in');
			res.push('notIn');
		} else if (type === 'text') {
			res.push('=');
			res.push('!=');
		} else {
			res.push('=');
			res.push('!=');
			res.push('<=');
			res.push('>=');
			res.push('<');
			res.push('>');
		}
		res.push('isNull');
		res.push('isNotNull');
	}
	return StaticLookup(
		Immutable.fromJS(
			res.map(key => {
				return {
					key,
					cells: [getPhrase('operator.' + key)]
				};
			})
		)
	);
}

let operatorLookups = {};

function getOperatorsForInput(type) {
	let res = operatorLookups[type];
	if (!res) {
		res = createOperatorsForInput(type);
		operatorLookups[type] = res;
	}
	return res;
}

class FilterEntityBlock extends React.PureComponent {
	constructor(props) {
		super(props);
		const entityName = props.entityName;
		const sourceUri = props.sourceUri;

		const filterColumns = props.filterColumns.map(fc => {
			const columns = fc.get('columns');
			return {
				name: fc.get('name'),
				type: fc.get('type'),
				dbName: fc.get('dbName'),
				columns,
				entityName,
				sourceUri
			};
		}).filter(fc => !!getFilterInputDefinition(fc));
		this.columnLookup = getColumnLookup(null, filterColumns, entityName);
		this.andColumnLookup = getColumnLookup('and', filterColumns, entityName);
		this.orColumnLookup = getColumnLookup('or', filterColumns, entityName);
		this.columnMap = mapColumns(filterColumns);

	}



	setFilter(value) {
		this.props.setFilter(value);
	}

	deleteNode(path) {
		if (path.length === 0) {
			this.setFilter(EMPTY_AND);
		} else {
			this.setFilter(this.getFilter().deleteIn(path))
		}
	}

	renderBlock(type, nodes, path, parentType) {
		const key = path.length > 0 ? path[path.length - 1] : 0;
		const childPathBase = path.concat('nodes');
		nodes = nodes.push(EMPTY_CONDITION);
		return (
			<React.Fragment key={key}>
				{
					key > 0 && (
						<BlockOperator>
							{getPhrase(parentType)}
						</BlockOperator>
					)
				}
				<BlockNode className={type + (path.length === 0 ? ' root' : '')}>
					<Icon
						name="delete"
						active
						className="negative"
						onMouseDown={e => {
							e.preventDefault();
							this.deleteNode(path);
						}}
					/>
					{
						nodes.map((node, index) => this.renderNode(node, childPathBase.concat(index), type))
					}
				</BlockNode>
			</React.Fragment>
		)
	}

	getFilter() {
		return this.props.filter || EMPTY_AND;
	}

	setColumnName(path, value) {
		let filter = this.getFilter();
		if (value.startsWith('s$block$')) {
			const blockType = value.substring('s$block$'.length);
			this.setFilter(filter.setIn(path, blockType === 'or' ? EMPTY_OR : EMPTY_AND));
		} else {
			let formItem = getFilterInputDefinition(this.columnMap[value]);
			let operator = null;
			if (formItem) {
				const operators = getOperatorsForInput(formItem.type);
				if (operators) {
					operator = operators.getItems().getIn([0, 'key']);
				}
			}
			this.setFilter(
				filter
					.setIn(path.concat('columnName'), value)
					.setIn(path.concat('formItem'), Immutable.Map(formItem))
					.setIn(path.concat('operator'), operator)
					.setIn(path.concat('value'), null)
					.setIn(path.concat('operatorFocusId'), getNextAutoFocusId())
					.deleteIn(path.concat('filter'))
			);
		}
	}

	setOperator(path, value) {
		let filter = this.getFilter();
		filter = filter.setIn(path.concat('operator'), value);
	/*	if (value === 'isNull' || value === 'isNotNull') {
			filter = filter.deleteIn(path.concat('value'));
		}*/
		this.setFilter(filter);
	}

	setValue(path, value) {
		this.setFilter(this.getFilter().setIn(path.concat('value'), value));
	}

	renderLookupInput(node, formItem, path) {
		let fixedParams = formItem.get('fixedParams');
		if (fixedParams && Immutable.Map.isMap(fixedParams)) {
			fixedParams = fixedParams.toJS();
		}
		const lu = getLookup(formItem.get('lookup'), fixedParams);
		if (!lu) {
			return (
				<span>invalid lookup - {formItem.get('lookup')}</span>
			);
		}
		return (
			<LookupListInput
				getRows={lu.getRows}
				getText={lu.getText}
				value={node.get('value')}
				combo={lu.supportsCombo}
				onChange={value => {
					this.setValue(path, value);
				}}
			/>
		);
	}

	renderInput(node, formItem, path) {
		const type = formItem.get('type');
		const placeholder = formItem.get('placeholder');
		if (type === 'lookup') {
			return this.renderLookupInput(node, formItem, path);
		}
		let Input;
		if (type === 'date') {
			Input = DateInput;
		} else if (type === 'number') {
			Input = NumberInput;
		} else {
			Input = TextInput;
		}
		return (
			<Input
				changeOnBlur
				value={node.get('value')}
				placeholder={placeholder}
				onChange={value => {
					this.setValue(path, value);
				}}
			/>
		);
	}

	renderCondition(node, path, parentType) {
		const lu = node !== EMPTY_CONDITION ? this.columnLookup : (parentType === 'or' ? this.orColumnLookup : this.andColumnLookup);
		const columnName = node.get('columnName');
		const key = path[path.length - 1];
		const formItem = node.get('formItem');
		let type;
		let luOperators;
		if (formItem) {
			type = formItem.get('type');
			luOperators = getOperatorsForInput(type);
		}
		const operator = node.get('operator');
		return (
			<React.Fragment key={key}>
				{
					key > 0 && (
						<BlockOperator>{getPhrase(parentType)}</BlockOperator>
					)
				}
				<Condition className={'condition ' + (type || '')} key={columnName}>
					<Cross>
						<FormItem label="" width="8px" marginRight="8px">
							<Icon
								name="delete"
								active
								className="negative"
								disabled={node === EMPTY_CONDITION}
								onMouseDown={e => {
									e.preventDefault();
									this.deleteNode(path);
								}}
							/>
						</FormItem>
						<FormItem label="" width="33%">
							<LookupInput
								mandatory
								getRows={lu.getRows}
								getText={lu.getText}
								combo
								value={columnName}
								onChange={value => {
									this.setColumnName(path, value);
								}}
							/>
						</FormItem>
						{
							node !== EMPTY_CONDITION && luOperators && (
								<FormItem label="" width="180px">
									<LookupInput
										mandatory
										getRows={luOperators.getRows}
										getText={luOperators.getText}
										combo
										autoFocusId={node.get('operatorFocusId')}
										value={operator}
										onChange={value => {
											this.setOperator(path, value);
										}}
									/>
								</FormItem>
							)
						}
						{
							node !== EMPTY_CONDITION && operator !== 'isNull' && operator !== 'isNotNull' && operator !== 'exists' && operator !== 'notExists' && (
								<FormItem label="">
									{this.renderInput(node, formItem, path)}
								</FormItem>
							)
						}
					</Cross>
					{
						(operator === 'exists' || operator === 'notExists') && (
							<SubqueryBlock>
								<FilterEntityBlock
									setFilter={filter => {
										this.setFilter(this.getFilter().setIn(path.concat('filter'), filter));
									}}
									entityName={this.props.entityName}
									sourceUri={this.props.sourceUri}
									filter={node.get('filter') || EMPTY_AND}
									filterColumns={this.columnMap[columnName].columns}
								/>
							</SubqueryBlock>
						)
					}
				</Condition>
			</React.Fragment>
		);
	}

	renderNode(node, path, parentType) {
		const type = node.get('type');
		if (type === 'and' || type === 'or') {
			return this.renderBlock(type, node.get('nodes') || EMPTY_LIST, path, parentType);
		} else {
			return this.renderCondition(node, path, parentType);
		}
	}

	render() {
		return this.renderNode(this.props.filter, []);
	}
}

export default class FilterEditor extends React.PureComponent {
	constructor(props) {
		super(props);
		this.onOk = this.onOk.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.clear = this.clear.bind(this);
		this.setFilter = this.setFilter.bind(this);
	}



	clear() {
		this.deleteNode([]);
	}

	onOk() {
		this.props.onCloseRequested(true);
	}

	onCancel() {
		this.props.onCloseRequested(false);
	}

	setFilter(value) {
		this.props.setFilterEditorFilter(value);
	}

	deleteNode(path) {
		if (path.length === 0) {
			this.setFilter(EMPTY_AND);
		} else {
			this.setFilter(this.getFilter().deleteIn(path))
		}
	}

	render() {
		const data = this.props.data;
		//console.log('filter = ', (data.get('filter') || EMPTY_AND).toJS());
		return (
			<Wrapper
				className="filterEditor"
				tabIndex="-1"
				onKeyDown={e => {
					const keyCode = e.keyCode;
					if (keyCode === 114) {
						e.preventDefault();
						e.target.closest('.filterEditor').focus();
						window.setTimeout(() => {
							this.onOk();
						}, 0);
					} else if (keyCode === 27) {
						if (!e.defaultPrevented) {
							this.onCancel();
						}
					}
				}}
			>
				<FlexBox vertical>
					<FlexBoxBlock flexGrow="1" overflow="auto">
						<Form
							vertical
							virtual
							onAction={this.onOk}
						>
							<FilterEntityBlock
								setFilter={this.setFilter}
								entityName={data.get('entityName')}
								sourceUri={data.get('sourceUri')}
								filter={data.get('filter') || EMPTY_AND}
								filterColumns={data.get('filterColumns')}
							/>
						</Form>
					</FlexBoxBlock>
					<FlexBoxBlock>
						<Buttons>
							<FlexBox>
								<FlexBoxBlock flexGrow="1">
									<Button
										text={getPhrase('clear')}
										type="light"
										onAction={this.clear}
										className="negative"
									/>
								</FlexBoxBlock>
								<FlexBoxBlock>
									<Button
										text={getPhrase('cancel')}
										type="light"
										onAction={this.onCancel}
										className="negative"
									/>
									<Button
										text={getPhrase('ok')}
										onAction={this.onOk}
										minWidth="120px"
									/>

								</FlexBoxBlock>
							</FlexBox>
						</Buttons>
					</FlexBoxBlock>
				</FlexBox>

			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	position: absolute;
	height: 90%;
	width: 90%;
	top: 5%;
	left: 50%;
	transform: translateX(-50%);
	padding: 16px;
	background: ${props => props.theme.boxBackground};

	border: ${props => props.theme.boxBorder};
	border-radius: ${props => props.theme.boxBorderRadius};
	background: ${props => props.theme.filterEditorAndBackground};
	border: ${props => props.theme.filterEditorAndBorder};

`;

const SubqueryBlock = styled.div`
	padding: 16px;
	margin: 4px;
	margin-top: 0px;
	margin-left: 32px;
`;

const Buttons = styled.div`
	.ps-button {
		margin-left: 16px;
	}
`;

const BlockOperator = styled.div`
	font-weight: 900;
	margin-left: 32px;
	text-transform: uppercase;
`;

const InlineBlockOperator = styled.div`
	display: inline-block;
	font-weight: 900;
	text-align: center;
	text-transform: uppercase;
	&.first {
		visibility: hidden;
	}
`;

const Condition = styled.div`
	padding: 0px 8px;

	&.subquery {
		margin-bottom: 4px;
		border-radius: 8px;
		padding: 4px 6px;
		background: ${props => props.theme.filterEditorSubqueryBackground};
		border: ${props => props.theme.filterEditorSubqueryBorder};
	}
`;

const BlockNode = styled.div`
	margin-bottom: 4px;
	padding: 8px;
	padding-right: 16px;
	border-radius: 8px;
	position: relative;

	> .icon[data-name=delete] {
		position: absolute;
		right: 4px;
		top: 2px;
	}


	&.and {
		background: ${props => props.theme.filterEditorAndBackground};
		border: ${props => props.theme.filterEditorAndBorder};
	}
	&.or {
		background: ${props => props.theme.filterEditorOrBackground};
		border: ${props => props.theme.filterEditorOrBorder};
	}
	&.root {
		padding: 0px;
		margin: 0px;
		border: none;
		background: transparent;
		> .icon[data-name=delete] {
			display: none;
		}
	}
`;
